import React, {useEffect, useMemo} from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {onLinkClicked} from "../functions";
import {useDispatch, useSelector} from "react-redux";
import uuid from 'react-uuid';
import {setUuid} from "@arboxappv4/shared/src/redux/kioskStandAlone/uuidSlice";
import {setKioskToken, setLinkError, validateKioskToken} from "@arboxappv4/shared/src/redux/kioskStandAlone/kioskSlice";
import {t} from "i18next";

const useKioskStandAloneInitialize = (props) => {
    const { ready } = props; //we need to wait for the translation to be ready
    const project_type = useSelector(state => state.project.project_type)
    const userUUID = useSelector(state => state.uuid.uuid)
    const token = useSelector(state => state.kiosk.token)
    const linkError = useSelector(state => state.kiosk.linkError)
    const [searchParams] = useSearchParams();
    const params = useMemo(() => Object.fromEntries([...searchParams]), [searchParams]);
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        if(!userUUID && project_type) {
            dispatch(setUuid(uuid()))
        }
    }, [userUUID, project_type]);

    useEffect(() => {
        if(!token && params.token) {
            dispatch(setKioskToken(params.token))
        }
    }, [token]);

    useEffect(() => {
        if(userUUID && token && project_type) {
            dispatch(validateKioskToken())
        }
    }, [token, userUUID, project_type]);

    useEffect(() => {
        if(linkError && ready) {
            dispatch(setLinkError(null))
            onLinkClicked('/404', navigate, {state: {notFoundHeader: t(`${linkError}-error-header`), notFoundSubHeader: t(`${linkError}-error`)}})
        }
    }, [linkError, ready]);

};

export default useKioskStandAloneInitialize;